/* eslint-disable */
/* eslint-disable no-restricted-syntax */
import { get } from 'lodash';
import { useEffect, useState } from 'react';
import _uniqueId from 'lodash/uniqueId';
// eslint-disable-next-line object-curly-newline
import { ArrowUpward, DeleteForever, FileCopy, ModeEdit, Upload, Visibility } from '@mui/icons-material';
import {
	IconButton, Menu, MenuItem, TextField, Tooltip
} from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { connect } from 'react-redux';
import { useHistory, useRouteMatch } from 'react-router';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Dropdown from 'rsuite/Dropdown';
import { classes, objectContainsProperty } from '../../Helpers';
// eslint-disable-next-line import/no-cycle
import { AlertModal } from '../Modals';
import styles from './ListTable.module.scss';
import excel from '../../Images/excel.svg';
import { Button } from '../ui/button';
import { modalActions } from '@/Actions';
import { useAuth } from '../Auth/Login/auth';
import { ArrowDown, ArrowUp, RefreshCcw } from 'lucide-react';

const ListTable = (props) => {
	// eslint-disable-next-line object-curly-newline
	const [uniqueId] = useState(_uniqueId('prefix'));
	const [editDisable, setEditDisable] = useState(true);
	const [anchorEl, setAnchorEl] = useState({});
	const [viewAnchorEl, setViewAnchorEl] = useState({});
	// const openMoreOptions = Boolean(anchorEl);
	const [editedValues, setEditedValues] = useState({});
	const {
		colMap,
		columns,
		renderColumn,
		data,
		actions,
		special,
		toggleAlert,
		// hasDateRange = false,
		handleClone,
		handleDelete,
		userPermissions,
		handleViewClick,
		handleEditSubmit,
		onExportClick,
		editable,
		renderBtns = () => { },
		showTotal,
		extraTotals = [],
		allowCheckList,
		generateProductionPlan,
		createSortingOrder,
		sortingType,
		productionMode = 'PP',
		onProductionModeChange,
		moreOptionsList,
		viewMoreOptionsList,
		removeComasOnExport = true,
		showBtnContainer = true,
		selectedRows = undefined,
		setSelectedRow = () => { },
		allowExport = true,
		allowChangeColumn = false,
		defaultVisibleColumns = null,
		importState = {
			show: false,
			handleImport: () => { },
		},
		isSortingEnabled = false,
		disabledRowSelection = false,
		fixedHeaderTop,
		exportRef = {},
		exportBackend = false,
		typeId = 0,
		disabledRowSelectionFn = () => false,
		removeRowSelectionFn = () => false,
		draftExists = false,
		draftOpenFn = () => { },
		emptyText = 'No items to display',
		handleSort = () => { },
		sortType = 'asc',
		handleRefresh = () => { },
		loading = false,
		showRefreshBtn = false,
		legend = null,
	} = props;

	const { url } = useRouteMatch();
	const history = useHistory();
	const { userConfig = {} } = useAuth();
	const { level } = userConfig?.userDetails || {};

	const [checkedList, setCheckedList] = useState([]);
	const navigateToItem = (id) => {
		history.push(`${url}/view/${id}`);
	};

	// eslint-disable-next-line no-unused-vars
	const [columnsToShow, setColumnsToShow] = useState([]);

	useEffect(() => {
		// defaultVisibleColumns lets a page start with only some of its togglable
		// columns shown (the rest stay in the "Columns" dropdown, just unchecked) -
		// every other caller that doesn't pass it keeps the old "everything visible"
		// default.
		if (defaultVisibleColumns) {
			setColumnsToShow(defaultVisibleColumns.map((title) => {
				return title?.toUpperCase();
			}));
		} else {
			setColumnsToShow(columns?.map((ele) => {
				return ele?.title?.toUpperCase();
			}));
		}
	}, [columns, defaultVisibleColumns]);

	useEffect(() => {
		if (selectedRows !== undefined) {
			setCheckedList(selectedRows || []);
		}
	}, [selectedRows]);

	function downloadCSV(csv, filename) {
		// CSV file
		const csvFile = new Blob([csv], {
			type: 'text/csv',
		});

		// Download link
		const downloadLink = document.createElement('a');

		// File name
		downloadLink.download = filename;

		// Create a link to the file
		downloadLink.href = window.URL.createObjectURL(csvFile);

		// Hide download link
		downloadLink.style.display = 'none';

		// Add the link to DOM
		document.body.appendChild(downloadLink);

		// Click download link
		downloadLink.click();
	}

	function codeValue(a = '') {
		return a.charCodeAt(0);
	}
	function exportTableToCSV(filename) {
		const csv = [];
		// const rows = document.querySelectorAll('table tr');
		const rows = document.querySelectorAll(`#${uniqueId} tr`);

		for (let i = 0; i < rows.length; i++) {
			const row = [];
			const cols = rows[i].querySelectorAll('td, th');

			for (let j = 0; j < cols.length; j++) {
				// row.push(cols[j].innerText?.replaceAll(',', '"'));
				// row.push(cols[j].innerText?.replaceAll(',', '-'));
				const p = cols[j].innerText;
				let outp = '';
				for (const a of p) {
					if (codeValue(a) > 255) {
						continue;
					}
					outp += a;
				}
				if (removeComasOnExport) {
					outp = outp.replace(',', '');
				}
				row.push(`"${(outp)}"`);
			}
			csv.push(row.join(','));
		}

		// Download CSV file
		downloadCSV(csv.join('\n'), filename);
	}

	exportRef.current = exportTableToCSV;

	const handleChangevalue = (value, id) => {
		setEditedValues((prev) => {
			return {
				...prev,
				[id]: value,
			};
		});
	};

	const handleSelection = (itemId, isChecked, all) => {
		const selectableItems =
			data?.filter((item) => !removeRowSelectionFn(item)) || [];
		if (all === 'selectAll') {
			const currentSelectionLength =
				(selectedRows || checkedList)?.length || 0;
			if (
				currentSelectionLength === selectableItems.length &&
				selectableItems.length > 0
			) {
				setSelectedRow?.([]);
				setCheckedList?.([]);
			} else {
				const allSelectableIds = selectableItems.map((ele) => {
					return ele?.id;
				});
				setSelectedRow?.(allSelectableIds);
				setCheckedList?.(allSelectableIds);
			}
		} else if (isChecked) {
			setSelectedRow?.((prev) => {
				return prev?.filter((ele) => {
					return ele !== itemId;
				});
			});
			setCheckedList?.((prev) => {
				return prev?.filter((ele) => {
					return ele !== itemId;
				});
			});
		} else {
			setSelectedRow?.((prev) => {
				return [...prev, itemId];
			});
			setCheckedList?.((prev) => {
				return [...prev, itemId];
			});
		}
		// } else {
		// 	// eslint-disable-next-line no-lonely-if
		// 	if (all === 'selectAll') {
		// 		if (checkedList?.length === data?.length) {
		// 		} else {
		// 			const allPOs = data?.map((ele) => {
		// 				return ele?.id;
		// 			});
		// 			setCheckedList(allPOs);
		// 		}
		// 	} else if (isChecked) {
		// 		setCheckedList((prev) => {
		// 			return prev?.filter((ele) => {
		// 				return ele !== itemId;
		// 			});
		// 		});
		// 	} else {
		// 		setCheckedList((prev) => {
		// 			return [...prev, itemId];
		// 		});
		// 	}
		// }
	};

	const handleMoreOptClick = (event, id) => {
		setAnchorEl({
			[id]: event.currentTarget,
		});
	};
	const handleCloseMoreOptions = () => {
		setAnchorEl(null);
	};
	const handleViewMoreOptClick = (event, id) => {
		setViewAnchorEl({
			[id]: event.currentTarget,
		});
	};
	const handleCloseViewMoreOptions = () => {
		setViewAnchorEl(null);
	};

	const generateActionBtns = (item) => {
		const {
			id,
			_name = null,
			orderStatus = null,
			orderId = null,
			mobile = null,
			paymentStatus,
			// paymentType,
		} = item;

		const openMoreOptions = Boolean(anchorEl?.[id]);
		const openViewMoreOptions = Boolean(viewAnchorEl?.[id]);

		const actionBtns = {
			Clone: (
				<td className={`${styles['action-item']}`}>
					<FileCopy
						className={`${styles['action-btn']} ${styles.clone}`}
						onClick={() => {
							handleClone(id);
						}}
					/>
				</td>
			),
			View: (
				<td className={`${styles['action-item']}`}>
					<Visibility
						className={`${styles['action-btn']} ${styles.view}`}
						onClick={() => {
							if (handleViewClick) return handleViewClick(item);
							return navigateToItem(id);
						}}
					/>
				</td>
			),
			Delete: (
				<td className={`${styles['action-item']}`}>
					<DeleteForever
						className={`${styles['action-btn']} ${styles.delete}`}
						onClick={() => {
							toggleAlert(true, {
								heading: 'Delete Item?',
								message: `Click Proceed to delete item ${_name != null ? `- ${_name}` : ''
									}`,
								id,
								height: 'fit-content',
							});
						}}
						fontSize='large'
					/>
				</td>
			),
			Cancel: (
				<td className={`${styles['action-item']}`}>
					{orderStatus !== 'Refunded' &&
						orderStatus !== 'Order Cancelled / Payment Failed' &&
						paymentStatus === 'TXN_SUCCESS' ? (
						<Button
							className='danger-btn'
							onClick={() => {
								toggleAlert(true, {
									heading: 'Cancel Order?',
									message: `Click Proceed to cancel order ${_name != null ? `- ${_name}` : ''
										}`,
									id,
									orderId,
									// storeName,
									mobile,
								});
							}}
						>
							Cancel
						</Button>
					) : (
						'-'
					)}
				</td>
			),
			'Change Value': (
				<td className={`${styles['action-item']}`}>
					<Tooltip
						title={
							editDisable ? 'Click On Edit Button to enable' : ''
						}
					>
						<TextField
							type='number'
							variant='outlined'
							margin='normal'
							fullWidth
							name='value'
							onChange={(e) => {
								return handleChangevalue(e?.target?.value, id);
							}}
							disabled={editDisable}
						/>
					</Tooltip>
				</td>
			),
			MORE: (
				<td className={`${styles['action-item']}`}>
					<div
						style={{
							position: 'relative',
						}}
					>
						<IconButton
							aria-label='more'
							id='long-button'
							aria-controls={openMoreOptions ? 'long-menu' : undefined}
							aria-expanded={openMoreOptions ? 'true' : undefined}
							aria-haspopup='true'
							onClick={(e) => {
								handleMoreOptClick(e, id);
							}}
						>
							<MoreVertIcon />
						</IconButton>
					</div>
					<Menu
						id='long-menu'
						MenuListProps={{
							'aria-labelledby': 'long-button',
						}}
						anchorEl={anchorEl?.[id]}
						open={openMoreOptions}
						onClose={handleCloseMoreOptions}
						PaperProps={{
							style: {
								maxHeight: '200px',
								width: '25ch',
							},
						}}
					>
						{Object.keys(moreOptionsList ?? {})?.map(
							(optionKey) => {
								const optionValue =
									moreOptionsList?.[optionKey];
								return (
									<MenuItem
										key={optionKey}
										// selected={optionKey === 'Pyxis'}
										onClick={() => {
											optionValue(item, handleCloseMoreOptions);
										}}
									>
										{optionKey}
									</MenuItem>
								);
							}
						)}
					</Menu>
				</td>
			),
			'View More': (
				<td className={`${styles['action-item']}`}>
					<div
						style={{
							position: 'relative',
						}}
					>
						<IconButton
							aria-label='view'
							id='view-long-button'
							aria-controls={viewMoreOptionsList ? 'long-view-menu' : undefined}
							aria-expanded={viewMoreOptionsList ? 'true' : undefined}
							aria-haspopup='true'
							onClick={(e) => {
								handleViewMoreOptClick(e, id);
							}}
						>
							<VisibilityIcon />
						</IconButton>
					</div>
					<Menu
						id='long-view-menu'
						MenuListProps={{
							'aria-labelledby': 'view-long-button',
						}}
						anchorEl={viewAnchorEl?.[id]}
						open={openViewMoreOptions}
						onClose={handleCloseViewMoreOptions}
						PaperProps={{
							style: {
								maxHeight: '200px',
								width: '25ch',
							},
						}}
					>
						{Object.keys(viewMoreOptionsList ?? {})?.map(
							(optionKey) => {
								const optionValue =
									viewMoreOptionsList?.[optionKey];
								return (
									<MenuItem
										key={optionKey}
										// selected={optionKey === 'Pyxis'}
										onClick={() => {
											optionValue(item, handleCloseViewMoreOptions);
										}}
									>
										{optionKey}
									</MenuItem>
								);
							}
						)}
					</Menu>
				</td>
			),
		};
		return actions
			.filter((action) => {
				if (action?.config?.type?.toLowerCase() === 'cancel') {
					return level !== 1;
				}
				if (action?.config?.type?.toLowerCase() === 'delete') {
					return level !== 1;
				}
				if (action?.config?.type?.toLowerCase() === 'view') {
					return true;
				}
				if (action?.config?.type?.toLowerCase() === 'annotate') {
					return level !== 1;
				}
				if (
					action?.config?.type?.toLowerCase() === 'edit' ||
					action?.config?.type?.toLowerCase() === 'update' ||
					action?.config?.type?.toLowerCase() === 'enabled'
				) {
					return level !== 1;
				}
				return true;
			})
			.map((action) => {
				const { title = action } = action;
				if (objectContainsProperty(actionBtns, title)) {
					return actionBtns[title];
				}
				const prop = colMap[title];
				const val = item[prop];
				const customCell = renderColumn(title, item);
				if (customCell != null) {
					if (
						!Array.isArray(customCell) &&
						typeof customCell === 'object' &&
						customCell.component
					) {
						return <td key={title}>{customCell.component}</td>;
					}
					return <td key={title}>{customCell}</td>;
				}
				return (
					<td className={`${styles['action-item']}`}>
						{special
							? special[title] && special[title](id, val)
							: ''}
					</td>
				);
			});
	};

	const handleColumnsToShowSelect = (column) => {
		if (columnsToShow?.includes(column)) {
			setColumnsToShow((prev) => {
				return prev?.filter((ele) => {
					return ele !== column;
				});
			});
		} else {
			setColumnsToShow((prev) => {
				return [...prev, column];
			});
		}
	};

	const getSortBasedOnCol = (col) => {
		const { config } = col;
		const { sortable } = config;
		if (sortable) {
			if (sortType === 'asc') {
				return <ArrowUp size={16} onClick={() => handleSort('asc', col)} className='absolute right-[2rem] top-[2.2rem] cursor-pointer' />;
			}
			if (sortType === 'desc') {
				return <ArrowDown size={16} onClick={() => handleSort('desc', col)} className='absolute right-[2rem] top-[2.2rem] cursor-pointer' />;
			}
			return <ArrowUp size={16} onClick={() => handleSort('asc', col)} className='absolute right-[2rem] top-[2.2rem] cursor-pointer' />;
		}
		return null;
	};

	const getHeaderTop = () => {
		if (fixedHeaderTop) {
			return fixedHeaderTop;
		}
		return showBtnContainer ? '50px' : '0px';
	};
	const headerTopPosition = getHeaderTop();
	return (
		<>
			{/* {typeId === 9 && } */}
			{showBtnContainer && (
				<div className={styles['btns-container']}>
					{showRefreshBtn && (
						<Tooltip title='Refresh'>
							<RefreshCcw size={20} className={`cursor-pointer ${loading ? 'animate-spin' : ''}`} onClick={handleRefresh} />
						</Tooltip>
					)}
					{editable && !editDisable && (
						<Button
							className='primary-btn'
							onClick={() => {
								if (!editDisable) {
									setEditDisable(true);
									handleEditSubmit(editedValues);
								}
							}}
						>
							Submit
						</Button>
					)}
					{legend}
					{renderBtns()}
					{draftExists && !selectedRows && checkedList?.length > 0 && (
						<Button
							className='bg-gradient-to-r from-purple-500 to-pink-500 hover:from-purple-600 hover:to-pink-600 rounded-md flex items-center justify-center gap-2 text-white shadow-lg transform transition-all duration-1000 hover:scale-105'
							onClick={draftOpenFn}
						>
							<svg
								xmlns='http://www.w3.org/2000/svg'
								className='h-5 w-5'
								viewBox='0 0 20 20'
								fill='currentColor'
							>
								<path d='M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z' />
							</svg>
							Edit Draft
						</Button>
					)}
					{sortingType === 'MANUAL' && (
						<div className='flex items-center gap-3 text-[13px] text-gray-700'>
							<label className='flex items-center gap-1 cursor-pointer'>
								<input
									type='radio'
									name='productionMode'
									value='PP'
									checked={productionMode === 'PP'}
									onChange={() => onProductionModeChange && onProductionModeChange('PP')}
								/>
								Production Plan
							</label>
							<label className='flex items-center gap-1 cursor-pointer'>
								<input
									type='radio'
									name='productionMode'
									value='SORTING'
									checked={productionMode === 'SORTING'}
									onChange={() => onProductionModeChange && onProductionModeChange('SORTING')}
								/>
								Primary Packaging Order
							</label>
						</div>
					)}
					{(selectedRows?.length > 0 || checkedList?.length > 0) && (
						sortingType === 'MANUAL' && productionMode === 'SORTING' ? (
							<Button
								className='primary-btn'
								onClick={() => {
									createSortingOrder(checkedList);
								}}
							>
								Create Primary Packaging Order
							</Button>
						) : (
							<Button
								className='primary-btn'
								onClick={() => {
									generateProductionPlan(checkedList);
								}}
							>
								Generate Production Plan
							</Button>
						)
					)}
					{showTotal && (
						<div
							className={`${styles.total} ${exportBackend ? 'mr-[8rem]' : ''
								}`}
						>
							<p>Total: </p>
							<p>{data?.length}</p>
						</div>
					)}
					{extraTotals?.map((extra) => (
						<div key={extra?.label} className={styles.total}>
							<p>{extra?.label}: </p>
							<p>{extra?.value}</p>
						</div>
					))}
					{allowExport && (
						<div
							onClick={() => {
								if (onExportClick) {
									onExportClick();
									return;
								}
								exportTableToCSV(
									props?.exportFilename || 'Table data'
								);
							}}
							className={styles.downloadData}
						>
							<img src={excel} alt='excel' />
							EXPORT
						</div>
					)}
					{importState?.show && (
						<div
							onClick={() => {
								importState?.handleClick();
							}}
							className={styles.import_data}
						>
							<Upload />
							IMPORT
						</div>
					)}
					{allowChangeColumn && (
						<Dropdown title='Columns' placement='bottomEnd'>
							{columns?.map((ele) => {
								const currCol = ele?.title?.toUpperCase();
								const isColumnChecked =
									columnsToShow?.includes(currCol);
								return (
									// No `active`/`onSelect` here on purpose: rsuite wires both
									// to its own click handler, which (a) paints the item with
									// the theme's "active" background - orange in this app's
									// theme, unreadable against the blue text - and (b) closes
									// the whole menu on every single pick, which defeats
									// checking several columns in one go. The checkbox below
									// stops that same click from ever reaching rsuite's
									// handler, so the menu stays open and only our own
									// checkbox styling shows the checked state.
									<Dropdown.Item
										key={currCol}
										className={styles.column_dropdown}
									>
										<label
											className={
												styles.column_checkbox_label
											}
											onClick={(e) => {
												e.stopPropagation();
												handleColumnsToShowSelect(
													currCol
												);
											}}
										>
											<input
												type='checkbox'
												checked={isColumnChecked}
												readOnly
											/>
											{currCol}
										</label>
									</Dropdown.Item>
								);
							})}
						</Dropdown>
					)}
				</div>
			)}
			<table
				id={uniqueId}
				className={`${styles['list-table-root']}`}
			>
				<thead>
					<tr>
						{allowCheckList ? (
							<th
								style={{
									top: headerTopPosition,
								}}
							>
								<div
									style={{
										display: 'flex',
										gap: '0.5rem',
									}}
								>
									<input
										checked={
											(function () {
												const selectableItems =
													data?.filter(
														(item) =>
															!removeRowSelectionFn(item)
													) || [];
												return (
													selectableItems?.length >
													0 &&
													(
														selectedRows ||
														checkedList
													)?.length ===
													selectableItems?.length
												);
											})()
										}
										disabled={disabledRowSelection}
										onChange={() => {
											handleSelection(
												null,
												null,
												'selectAll'
											);
										}}
										type='checkbox'
										className='list-select-input'
									/>
									{/* Select */}
								</div>
							</th>
						) : null}
						{[
							...columns?.filter((ele) => {
								return columnsToShow?.includes(
									ele?.title?.toUpperCase()
								);
							}),
							...actions,
						]
							.filter((action) => {
								if (
									action?.config?.type?.toLowerCase() ===
									'cancel'
								) {
									return level !== 1;
								}
								if (
									action?.config?.type?.toLowerCase() ===
									'delete'
								) {
									return level !== 1;
								}
								if (
									action?.config?.type?.toLowerCase() ===
									'view'
								) {
									return true;
								}
								if (
									action?.config?.type?.toLowerCase() ===
									'annotate'
								) {
									return level !== 1;
								}
								if (
									action?.config?.type?.toLowerCase() ===
									'edit' ||
									action?.config?.type?.toLowerCase() ===
									'update' ||
									action?.config?.type?.toLowerCase() ===
									'enabled'
								) {
									return level !== 1;
								}
								return true;
							})
							.map((col) => {
								const { title, config } = col;
								const customCol = renderColumn(title);
								if (customCol != null) {
									if (
										!Array.isArray(customCol) &&
										typeof customCol === 'object'
									) {
										return (
											<th
												className={styles['custom-col']}
												style={{
													top: headerTopPosition,
													...config?.style,
												}}
												colSpan={customCol?.colSpan}
											>
												{customCol?.component}
											</th>
										);
									}
									return (
										<th
											className={styles['custom-col']}
											style={{
												top: headerTopPosition,
												...config?.style,
											}}
										>
											{customCol}
											{config?.sortable && getSortBasedOnCol(col)}
										</th>
									);
								}
								if (title === 'Change Value') {
									return (
										<th
											className={styles['change-value']}
											style={{
												top: headerTopPosition,
												...config?.style,
											}}
										>
											Change Value
											{editDisable &&
												data?.length > 0 && (
													<div
														onClick={() => {
															setEditDisable(
																false
															);
														}}
														className={styles.icon}
													>
														<ModeEdit />
													</div>
												)}
										</th>
									);
								}
								return (
									<th
										key={title}
										className={
											columns?.length < 4
												? styles.center
												: ''
										}
										style={{
											top: headerTopPosition,
											...config?.style,
										}}
									>
										{title === 'Cancel'
											? 'Cancel Order'
											: title}
										{config?.sortable && getSortBasedOnCol(col)}
									</th>
								);
							})}
					</tr>
				</thead>
				<tbody>
					{data?.map((item, idx) => {
						const newLocal = item?.onClick
							? {
								onClick: item.onClick,
							}
							: {};
						const isChecked = selectedRows
							? selectedRows?.includes(item?.id)
							: checkedList?.includes(item?.id);
						const isRowSelectionDisabled =
							disabledRowSelectionFn(item);
						return (
							<tr
								key={idx}
								className={classes(
									item?.rowStyles ??
									(idx % 2 === 0 ? styles.default : ''),
									'hover:bg-slate-100'
								)}
								style={item?.styleCss}
								{...newLocal}
							>
								{allowCheckList && (
									// Selecting a row must not also open it: keep clicks in the
									// checkbox cell from reaching the row's onClick.
									<td onClick={(e) => e.stopPropagation()}>
										{!removeRowSelectionFn(item) && (
											<input
												type='checkbox'
												checked={isChecked}
												disabled={
													disabledRowSelection ||
													isRowSelectionDisabled
												}
												onChange={() => {
													if (!isRowSelectionDisabled) {
														handleSelection(
															item?.id,
															isChecked
														);
													}
												}}
											/>
										)}
									</td>
								)}
								{columns
									.filter((action) => {
										if (
											action?.config?.type?.toLowerCase() ===
											'cancel'
										) {
											return level !== 1;
										}
										if (
											action?.config?.type?.toLowerCase() ===
											'delete'
										) {
											return level !== 1;
										}
										if (
											action?.config?.type?.toLowerCase() ===
											'view'
										) {
											return true;
										}
										if (
											action?.config?.type?.toLowerCase() ===
											'update' ||
											action?.config?.type?.toLowerCase() ===
											'enabled'
										) {
											return level !== 1;
										}
										return columnsToShow?.includes(
											action?.title?.toUpperCase()
										);
									})
									.map((col) => {
										const { title } = col;
										const prop = colMap[title];
										const value = get(item, prop);
										const customCell = renderColumn(
											title,
											item
										);
										if (customCell != null) {
											if (
												!Array.isArray(customCell) &&
												typeof customCell ===
												'object' &&
												customCell.component
											) {
												return (
													<td key={title}>
														{customCell.component}
													</td>
												);
											}
											return (
												<td key={title}>
													{customCell}
												</td>
											);
										}
										if (
											objectContainsProperty(
												special,
												title
											)
										) {
											if (Array.isArray(value)) {
												return special[title](value) ===
													null ||
													special[title](value) === ''
													? ''
													: special[title](value);
											}
											return (
												<td key={title}>
													{special[title](
														value,
														item
													) === null ||
														special[title](
															value,
															item
														) === ''
														? ''
														: special[title](
															value,
															item
														)}
												</td>
											);
										}
										return (
											<td key={title}>
												{value === null || value === ''
													? ''
													: value}
											</td>
										);
									})}
								{generateActionBtns(item)}
							</tr>
						);
					})}
					{data?.length === 0 || data === null ? (
						<tr className={styles.fallback}>
							<td colSpan={[...columns, ...actions].length}>
								{emptyText}
								<br />
							</td>
						</tr>
					) : null}
				</tbody>
			</table>
			<AlertModal
				handleConfirm={(args) => {
					handleDelete(args);
					toggleAlert(false);
				}}
			/>
		</>
	);
};

ListTable.defaultProps = {
	columns: [],
	actions: [],
	special: {},
	sticky: true,
	data: [],
	renderColumn: () => {
		return null;
	},
	fixedHeaderTop: '',
};

const mapStateToProps = (state) => {
	const { userPermissions } = state.navigation;
	return {
		userPermissions,
	};
};

const mapDispatchToProps = {
	toggleAlert: modalActions.toggleAlert,
};

export default connect(mapStateToProps, mapDispatchToProps)(ListTable);
